import type { FC } from 'react'
import GenericTable from '../../../../cars/components/V3/_shared/GenericTable/GenericTable'
import type { FleetReportExpense } from '../../../../../types'
import { fleetReportExpenseColumns } from './fleetReportExpenseTableData'
import type { Row } from '@tanstack/react-table'
import { formatNumber } from '../../utils/formatNumber'
import TableMobileCardContent from '../../../../cars/components/V3/_shared/GenericTable/TableMobileCardContent'
import { formatDate } from '../../../../cars/components/V3/helpers/formatDate'

interface FleetReportExpenseTableProps {
  data: FleetReportExpense[]
}

const FleetReportExpenseTable: FC<FleetReportExpenseTableProps> = ({ data }) => {
  return (
    <GenericTable
      data={data}
      columns={fleetReportExpenseColumns}
      mobileCardContent={(row) => {
        return <MobileCardContent row={row as Row<FleetReportExpense>} />
      }}
    />
  )
}

export default FleetReportExpenseTable

function MobileCardContent({ row }: { row: Row<FleetReportExpense> }) {
  const settings = { digits: { min: 0, max: 0 }, prefix: 'kr ' }
  const { productDescription, lineDescription, documentNo, documentType, termDate, amountInclVAT } = row.original

  const data = [
    {
      label: 'Kostnadsart',
      value: productDescription || '',
    },
    {
      label: 'Detaljert beskrivelse',
      value: lineDescription || '',
    },
    {
      label: 'Dokumentnr',
      value: documentNo || '',
    },
    {
      label: 'Dokumenttype',
      value: documentType || '',
    },
    {
      label: 'Terminsdato',
      value: formatDate(termDate) || '',
    },
    {
      label: 'Beløp inkl. mva',
      value: formatNumber(amountInclVAT || 0, settings),
    },
  ]
  const header = `${productDescription || 'Utgift'} - ${lineDescription || ''}`
  return <TableMobileCardContent header={header} data={data} />
}
